import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from '../services/auth-service.service';
import { AppGlobalsService } from '../services/app-globals.service';
import { UnifiedReportingComponent } from './unified-reporting/unified-reporting.component';

const routes: Routes = [
  {
    path: 'reporting',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: UnifiedReportingComponent,
        canActivate: [AuthService],
        data: {
          breadcrumb: 'reporting',
          rightNeeded: 'ReportingTabInMenu',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportingRouting {}
